import React from 'react';
import PoweredByMyinterviewImage from '../../assets/images/poweredbymyinterview.svg';

export const PoweredByMyinterview: React.FC = () => (
  <div className="powered-by-my-interview main-container">
    <img src={PoweredByMyinterviewImage} alt="Powered By MyInterview" />
  </div>
);
